//  Custom selectbox - select2
$(function () {
	$('.dropdown-select').select2({
		width: '100%',
		minimumResultsForSearch: -1,
	});
});
